// transform
export const SET_TITLE = 'SET_TITLE'
export const SET_INPUT = 'SET_INPUT'
export const SET_PLACEHOLDER = 'SET_PLACEHOLDER'
export const SET_INPUT_LANG = 'SET_INPUT_LANG'
export const SET_OUTPUT_LANG = 'SET_OUTPUT_LANG'
export const SET_TRANSFORMERS = 'SET_TRANSFORMERS'
export const SET_MODES = 'SET_MODES'
export const SELECT_MODE = 'SELECT_MODE'
export const SET_DETECT_LANGUAGE = 'SET_DETECT_LANGUAGE'

// user
export const SET_USER = 'SET_USER'




// WEBPACK FOOTER //
// ./src/store/mutation-types.ts